import { ViewState } from 'ms-map-gl'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'
import { useSelector } from 'react-redux'

type MsViewState = ViewState & { style?: any }

type State = Partial<MsViewState>

const initialState: State = {
  style: null,
  bearing: undefined,
  latitude: undefined,
  longitude: undefined,
  padding: undefined,
  pitch: undefined,
  zoom: undefined
}

export const viewStateSlice = createSlice({
  name: 'viewState',
  initialState,
  reducers: {
    setStyle: (state, action: PayloadAction<any>) => {
      state.style = action.payload
    },
    resetStyle: (state) => {
      state.style = null
    },
    setViewState: (state, action: PayloadAction<ViewState>) => {
      state.bearing = action.payload.bearing
      state.latitude = action.payload.latitude
      state.longitude = action.payload.longitude
      state.padding = action.payload.padding
      state.pitch = action.payload.pitch
      state.zoom = action.payload.zoom
    }
  }
})

export const { setViewState, setStyle, resetStyle } = viewStateSlice.actions

// Memoized selector for style
const selectStyle = createSelector(
  (state: { viewState: State }) => state.viewState,
  (viewState) => viewState.style
)

// Memoized selector for view state
const selectViewState = createSelector(
  (state: { viewState: State }) => state.viewState,
  ({ bearing, latitude, longitude, padding, pitch, zoom }) => ({
    bearing,
    latitude,
    longitude,
    padding,
    pitch,
    zoom
  })
)

export const useStyle = () => useSelector(selectStyle)

export const useViewState = () => useSelector(selectViewState)

export default viewStateSlice.reducer
